export const API_ENDPOINTS = {
  REGISTER_CAPTCHA: '/register/captcha',
  REGISTER: '/register',
  PROFILE: '/profile',
  ADD_GROUP: '/group/add',
  AUTH: {
    LOGIN: '/login',
  },
};
